import React, { useMemo } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { CustomizableAutocomplete } from "../../UI";
import {
  ADDITIONAL_SUPPORT_OPTIONS,
  CARE_FOCUS_OPTIONS,
  composeCareFocusSelection,
  splitCareFocusSelection,
} from "../../../constants/childProfileOptions";

const normalizeOption = (item) => (
  typeof item === "string" ? { label: item, code: item.toUpperCase().replace(/\s+/g, "_") } : item
);

const CareFocusSelectionFields = ({
  value = [],
  onChange,
  fieldSx = {},
  stackSpacing = 1.2,
}) => {
  const { primaryFocus, additionalSupports } = useMemo(() => (
    splitCareFocusSelection(value)
  ), [value]);

  const handlePrimaryChange = (event) => {
    const nextPrimary = CARE_FOCUS_OPTIONS.find((option) => option.code === event.target.value) || null;
    onChange?.(composeCareFocusSelection(nextPrimary, additionalSupports));
  };

  const handleSupportsChange = (event, nextValue) => {
    onChange?.(composeCareFocusSelection(primaryFocus, nextValue.map(normalizeOption)));
  };

  return (
    <Stack spacing={stackSpacing}>
      <FormControl fullWidth sx={fieldSx}>
        <InputLabel id="primary-care-focus-label">Care focus *</InputLabel>
        <Select
          labelId="primary-care-focus-label"
          value={primaryFocus?.code || ""}
          label="Care focus *"
          onChange={handlePrimaryChange}
        >
          <MenuItem value="">Choose care focus</MenuItem>
          {CARE_FOCUS_OPTIONS.map((option) => (
            <MenuItem key={option.code} value={option.code}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <CustomizableAutocomplete
        options={ADDITIONAL_SUPPORT_OPTIONS}
        getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
        value={additionalSupports}
        onChange={handleSupportsChange}
        label="Additional supports"
        addText="Add support"
        helperText="Add anything else caregivers should keep in mind. These do not change the main app lens."
        sx={fieldSx}
      />
    </Stack>
  );
};

export default CareFocusSelectionFields;
